/**
 * Checks if an error message indicates a dynamic import/chunk loading failure.
 */
export function isDynamicImportError(errorMessage: string): boolean {
  return (
    errorMessage.includes("dynamically imported module") ||
    errorMessage.includes("Failed to fetch dynamically imported module") ||
    errorMessage.includes("Importing a module script failed") ||
    errorMessage.includes("Loading chunk") ||
    errorMessage.includes("Loading CSS chunk") ||
    errorMessage.includes("is not a valid JavaScript MIME type") ||
    errorMessage.includes("Load failed") // Safari equivalent of "Failed to fetch"
  );
}
